export const isIframePage = () => {
  return window.location.pathname === '/iframe';
};
